import { sanitizePdfText } from "helpers";
import { t } from "i18next";

import { OrderDetails } from "../../orders.types";

interface getDeliveryAndDriverProps {
  orderDetails: OrderDetails;
}

export const getDeliveryAndDriver = ({
  orderDetails
}: getDeliveryAndDriverProps) => {
  const deliveryZone = orderDetails.deliveryAddress.deliveryZone;
  const deliveryAddressNeighborhood = deliveryZone?.neighborhood;
  const deliveryAddressCity = deliveryZone?.city;
  const deliveryAddressCountry = deliveryZone?.country;

  const deliveryAddress = `${sanitizePdfText(orderDetails.deliveryAddress.fullName)}
${sanitizePdfText(orderDetails.deliveryAddress.phoneNumber)}
${sanitizePdfText(orderDetails.deliveryAddress.address)}, ${sanitizePdfText(deliveryAddressNeighborhood)}, ${sanitizePdfText(deliveryAddressCity)}, ${sanitizePdfText(deliveryAddressCountry)}.
${orderDetails.deliveryAddress.instructions ? `\n${t("Specific Instructions")}:\n${sanitizePdfText(orderDetails.deliveryAddress.instructions)}` : ""}`;

  const driver = orderDetails.driver;
  const driverName = sanitizePdfText(
    `${driver?.firstname ?? ""} ${driver?.lastname ?? ""}`
  );

  const driverDetails = driver
    ? `${driverName}\n${sanitizePdfText(driver?.phoneNumber)}\n${sanitizePdfText(driver?.plateNumber)}`
    : t("Not assigned");

  return {
    deliveryAddress,
    driverDetails
  };
};
